mutation UpdateAiSettingsLanguage($input: AiSettingsInput!) {
  updateAiSettings(input: $input) {
    language
  }
}
